import { MetodoPagoService } from "services";
import { ResponseExceptionHandlerHelper } from "utils";
import { WarningException } from "utils";

export const MetodoPagoManager = (() => {
  const { handleException } = ResponseExceptionHandlerHelper();
  const buscarPorId = (Id, esLookup) => {
    return MetodoPagoService.buscarPorId(Id, esLookup).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const listado = (where) => {
    return MetodoPagoService.listado(where).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const crear = (metodoPago) => {
    return MetodoPagoService.crear(metodoPago).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const actualizar = (metodoPago) => {
    return MetodoPagoService.actualizar(metodoPago).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const exportar = (where) => {
    return VendedorService.exportar(where).then((res) => {
      return res;
    });
  };

  return {
    buscarPorId,
    listado,
    crear,
    actualizar,
    exportar,
  };
})();
